/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import moment from "moment"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDBadge from "components/MDBadge"

// Utils
import { translateStatus } from "utils/translate/status"
import { generateColorPerStatus } from "utils/functions/switchStatusColor"

const StateCity = ({ state, city }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography display="block" variant="p" color="text" fontWeight="medium">
      {state}
    </MDTypography>
    <MDTypography variant="caption">{city}</MDTypography>
  </MDBox>
)

export default function returnsPackagesDataTable(trackingData) {
  return {
    columns: [
      { Header: "colis (ref)", accessor: "package", width: "10%", align: "left" },
      { Header: "code à barre", accessor: "barcode", width: "10%", align: "left" },
      { Header: "entreprise", accessor: "company", align: "left" },
      { Header: "client(e)", accessor: "client", align: "left" },
      { Header: "état/ville", accessor: "state", align: "left" },
      { Header: "téléphone", accessor: "clientPhoneNumber", align: "center" },
      { Header: "prix (tnd)", accessor: "price", align: "center" },
      { Header: "statut", accessor: "status", align: "center" },
      { Header: "manquant", accessor: "isMissing", align: "center" },
      { Header: "impression", accessor: "isPrinted", align: "center" },
      { Header: "date", accessor: "date", align: "center" },
    ],
    rows: trackingData.map((trackingItem) => ({
      package: (
        <MDTypography
          component="a"
          href={`colis/colis-details/${trackingItem.packageId}`}
          variant="p"
          color="text"
          fontWeight="medium"
        >
          #{trackingItem.reference}
        </MDTypography>
      ),
      barcode: (
        <MDTypography
          component="a"
          href={`colis/colis-details/${trackingItem.packageId}`}
          variant="p"
          color="text"
          fontWeight="medium"
        >
          {trackingItem.barcode}
        </MDTypography>
      ),
      company: (
        <MDTypography
          component="a"
          href={`colis/colis-details/${trackingItem.packageId}`}
          variant="p"
          color="text"
          fontWeight="medium"
        >
          {trackingItem.companyName}
        </MDTypography>
      ),
      client: (
        <MDTypography
          component="a"
          href={`colis/colis-details/${trackingItem.packageId}`}
          variant="p"
          color="text"
          fontWeight="medium"
        >
          {trackingItem.clientName}
        </MDTypography>
      ),
      state: <StateCity state={trackingItem.state} city={trackingItem.city} />,
      clientPhoneNumber: (
        <MDTypography
          component="a"
          href={`colis/colis-details/${trackingItem.packageId}`}
          variant="p"
          color="text"
          fontWeight="medium"
        >
          {trackingItem.clientPhoneNumber}
        </MDTypography>
      ),
      price: (
        <MDTypography
          component="a"
          href={`colis/colis-details/${trackingItem.packageId}`}
          variant="p"
          color="text"
          fontWeight="medium"
        >
          {trackingItem.packagePrice}
        </MDTypography>
      ),
      status: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={translateStatus(trackingItem.status)}
            sx={{
              ".MuiBadge-badge": {
                background: generateColorPerStatus(trackingItem.status),
              },
            }}
            variant="gradient"
            size="md"
          />
        </MDBox>
      ),
      isMissing: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={trackingItem.isMissing ? "oui" : "non"}
            color={trackingItem.isMissing ? "success" : "error"}
            variant="gradient"
            size="md"
          />
        </MDBox>
      ),
      isPrinted: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={trackingItem.isPrinted ? "Imprimé" : "Non Imprimé"}
            color={trackingItem.isPrinted ? "success" : "error"}
            variant="gradient"
            size="md"
          />
        </MDBox>
      ),
      date: (
        <MDTypography
          component="a"
          href={`colis/colis-details/${trackingItem.packageId}`}
          variant="p"
          color="text"
          fontWeight="medium"
        >
          {moment(trackingItem.createdAt).format("MMM DD, YYYY")}
        </MDTypography>
      ),
    })),
  }
}
